import { generateOnPickerChange, generateIsPickerSelected } from '@btime/helpers'
import { propOr } from 'ramda'
import React from 'react'

import { Text } from '../presentation/Text'
import Checkbox from '../shapes/Checkbox'
import FlexGrid from '../structure/FlexGrid'
import Link from '../actions/Link'
import Radio from '../shapes/Radio'
import Separator from '../helpers/Separator'

const DefaultSelector = ({ selected, option, multiple, labelField }) => {
  const Marker = multiple ? Checkbox : Radio
  return (
    <FlexGrid gutter={0.2}>
      <div>
        <Marker active={selected} />
      </div>
      <Text>{propOr(option.label, labelField || 'label', option)}</Text>
      <div>
        <Separator vertical />
      </div>
    </FlexGrid>
  )
}

const defaultRenderOption = React.memo(({ option, selected, multiple }) => <Text>{option.label}</Text>)

const OptionWrapper = ({ raw, renderOption, option, multiple, selected, onClick, labelField, disabled }) => {
  const content = renderOption({ option, selected, multiple, onClick, labelField })
  if (raw) return content

  return (
    <Link onClick={onClick} disabled={disabled || option.disabled}>
      {content}
    </Link>
  )
}

const Picker = ({ options, raw, onChange, value, multiple, idField, renderOption, Selector, labelField, ...props }) => {
  const handleChange = generateOnPickerChange(value, onChange, { multiple, idField })
  const isSelected = generateIsPickerSelected(value, { multiple, idField })

  Selector = Selector || DefaultSelector
  if (!renderOption) renderOption = props => <Selector {...props} />

  return (
    <FlexGrid wrap justify="flex-start" align="flex-start" paddingGutter={0.4} {...props}>
      {options.map(item => (
        <OptionWrapper
          option={item}
          key={propOr(item.value, idField || 'id', item.value)}
          selected={isSelected(item)}
          multiple={multiple}
          onClick={() => handleChange(item)}
          renderOption={renderOption}
          raw={raw}
          labelField={labelField}
          disabled={props.disabled}
        />
      ))}
    </FlexGrid>
  )
}

export default Picker
